export const EMAIL_CHANNEL_DELETE_FETCH = 'EMAIL_CHANNEL_DELETE_FETCH';
export const EMAIL_CHANNEL_DELETE_FETCH_FAIL =
  'EMAIL_CHANNEL_DELETE_FETCH_FAIL';
export const EMAIL_CHANNEL_DELETE_FETCH_SUCCESS =
  'EMAIL_CHANNEL_DELETE_FETCH_SUCCESS';

export const EMAIL_CHANNEL_CREATE_FETCH = 'EMAIL_CHANNEL_CREATE_FETCH';
export const EMAIL_CHANNEL_CREATE_FETCH_FAIL =
  'EMAIL_CHANNEL_CREATE_FETCH_FAIL';
export const EMAIL_CHANNEL_CREATE_FETCH_SUCCESS =
  'EMAIL_CHANNEL_CREATE_FETCH_SUCCESS';

export const EMAIL_CHANNEL_LIST_FETCH = 'EMAIL_CHANNEL_LIST_FETCH';
export const EMAIL_CHANNEL_LIST_FETCH_FAIL = 'EMAIL_CHANNEL_LIST_FETCH_FAIL';
export const EMAIL_CHANNEL_LIST_FETCH_SUCCESS =
  'EMAIL_CHANNEL_LIST_FETCH_SUCCESS';

export const EMAIL_CHANNEL_SEARCH_LIST_FETCH =
  'EMAIL_CHANNEL_SEARCH_LIST_FETCH';
export const EMAIL_CHANNEL_SEARCH_LIST_FETCH_FAIL =
  'EMAIL_CHANNEL_SEARCH_LIST_FETCH_FAIL';
export const EMAIL_CHANNEL_SEARCH_LIST_FETCH_SUCCESS =
  'EMAIL_CHANNEL_SEARCH_LIST_FETCH_SUCCESS';

export const EMAIL_CHANNEL_UPDATE_FETCH = 'EMAIL_CHANNEL_UPDATE_FETCH';
export const EMAIL_CHANNEL_UPDATE_FETCH_FAIL =
  'EMAIL_CHANNEL_UPDATE_FETCH_FAIL';
export const EMAIL_CHANNEL_UPDATE_FETCH_SUCCESS =
  'EMAIL_CHANNEL_UPDATE_FETCH_SUCCESS';

export const EMAIL_CHANNEL_UPDATE_SUBMIT_FETCH =
  'EMAIL_CHANNEL_UPDATE_SUBMIT_FETCH';
export const EMAIL_CHANNEL_UPDATE_SUBMIT_FETCH_FAIL =
  'EMAIL_CHANNEL_UPDATE_SUBMIT_FETCH_FAIL';
export const EMAIL_CHANNEL_UPDATE_SUBMIT_FETCH_SUCCESS =
  'EMAIL_CHANNEL_UPDATE_SUBMIT_FETCH_SUCCESS';

export const EMAIL_CHANNEL_CHANGE_CURRENT = 'EMAIL_CHANNEL_CHANGE_CURRENT';
export const EMAIL_CHANNEL_PAGE_CHANGE_CURRENT =
  'EMAIL_CHANNEL_PAGE_CHANGE_CURRENT';
